import React from "react";
import { ModalComponent } from "../../../components/Modal.components";
import { PageTitle } from "../../../components/style";
import { Button } from "../../../components/Button.components";
import { Boxed } from "../../../components/Boxed.components";
import { Grid } from "../../../components/Grid.components";
import { Input } from "../../../components/Input.components";

export const ViewUser = (props) => {
  //State props

  const { viewUserModal, userData } = props;

  //Dispatch props

  const {
    closeModal,
    form: { getFieldProps, getFieldError },
  } = props;
  return (
    <ModalComponent
      show={viewUserModal}
      onHide={closeModal}
      title={<PageTitle margin="5px 0">User Profile</PageTitle>}
      footer={
        <Boxed display="flex" width="100%">
          <Button clear onClick={closeModal}>
            Cancel
          </Button>
        </Boxed>
      }
    >
      <Boxed
        margin="10px auto"
        display="flex"
        flexDirection="column"
        alignItems="center"
        position="relative"
      >
        <img
          src={userData?.profilePictureUrl}
          alt="profile"
          style={{
            width: "160px",
            height: "160px",
            borderRadius: "9999px",
            border: "1px solid #ccc",
          }}
        />
      </Boxed>
      <Grid
        desktop="repeat(2, 1fr)"
        tablet="repeat(2, 1fr)"
        mobile="repeat(1,1fr)"
        pad="0 0 30px 0"
      >
        <Boxed pad="10px 0">
          <Input
            type="text"
            label="First Name"
            placeholder="Enter first name..."
            disabled
            error={getFieldError("firstname") ? "First name is required" : null}
            {...getFieldProps("firstname", {
              initialValue: userData?.firstName,
              rules: [{ required: true }],
            })}
          />
        </Boxed>
        <Boxed pad="10px 0">
          <Input
            type="text"
            label="Last Name"
            placeholder="Enter last name..."
            error={getFieldError("lastname") ? "Last name is required" : null}
            disabled
            {...getFieldProps("lastname", {
              initialValue: userData?.lastName,
              rules: [{ required: true }],
            })}
          />
        </Boxed>

        <Boxed pad="10px 0">
          <Input
            type="text"
            label="Email"
            placeholder="Enter email..."
            disabled
            error={getFieldError("email") ? "Email is required" : null}
            {...getFieldProps("email", {
              initialValue: userData?.email,
              rules: [{ required: true, email: true }],
            })}
          />
        </Boxed>

        <Boxed pad="10px 0">
          <Input
            type="text"
            label="Phone Number"
            disabled
            placeholder="Enter phone number..."
            error={getFieldError("phone") ? "Phone number is required" : null}
            {...getFieldProps("phone", {
              initialValue: `${userData?.phoneNumber?.countryCode}${userData?.phoneNumber?.phone}`,
              rules: [{ required: true }],
            })}
          />
        </Boxed>

        <Boxed pad="10px 0">
          <Input
            type="text"
            label="User Type"
            placeholder="Enter email..."
            disabled
            error={getFieldError("email") ? "Email is required" : null}
            {...getFieldProps("email", {
              initialValue: userData?.userType?.description,
              rules: [{ required: true, email: true }],
            })}
          />
        </Boxed>

        <Boxed pad="10px 0">
          <Input
            type="text"
            label="User Status"
            disabled
            placeholder="Enter phone number..."
            error={
              getFieldError("createdDate") ? "Phone number is required" : null
            }
            {...getFieldProps("createdDate", {
              initialValue: userData?.status,
              rules: [{ required: true }],
            })}
          />
        </Boxed>
      </Grid>
    </ModalComponent>
  );
};
